import React from 'react'
import styled from '@emotion/styled'

const Row = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

const Image = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 8px;
  object-fit: cover;
  border: 1px solid #ddd;
`

const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
`

const ProductName = styled.span`
  line-height: 1.2;
  font-weight: 600;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

const Price = styled.span`
  font-weight: 600;
  color: #003f9e;
`

export default function ProductMiniCard({
  image,
  name,
  price,
  quantity,
  nameOnly = false,
}) {
  return (
    <Row>
      <Image src={image} alt={name} />

      <ProductInfo>
        <ProductName>{name}</ProductName>

        {!nameOnly && (
          <>
            <span>Qty: {quantity}</span>
            <Price>{price ? `Rp ${price.toLocaleString()}` : ''}</Price>
          </>
        )}
      </ProductInfo>
    </Row>
  )
}
